

import React from 'react';
import TrafficFee from './TrafficFeeV1';
import './style.css';
import '../../Style/defaultstyle.scss'

const ProtitleNew = (params) => {
  return (
    <table style={params.classNameWrapper}>
      <tr style={params.classNameItem}>
        <td style={params.PadProTitle}>
          <text style={StySpecification.ColorText} className='sub-title'>{params.Title} </text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
          <text style={params.ConTitle}><span  >{params.Core} </span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.G} </span></text>
        </td>
      </tr>
      <tr style={params.Tableborder}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.SD}</span></text>
        </td>
      </tr>
      <tr style={params.Tableborderlast}>
        <td style={params.PadPro} >
        <text style={params.ConTitle}><span  >{params.SG}</span></text>
        </td>
      </tr>
    </table>
  )
}

const Protitle = (params) => {
  return (
    <table style={params.classNameWrapper}>
      <tr>
        <td style={params.PadProTable} >
          <text style={StySpecification.ColorText} className='sub-title'>&nbsp;</text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
          <text style={params.ConTitle}><span  >{params.Core} </span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.G} </span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.SD}</span></text>
        </td>
      </tr>
      <tr>
        <td style={params.PadProtit} >
        <text style={params.ConTitle}><span  >{params.SG}</span></text>
        </td>
      </tr>
    </table>
  )
}

function ServerPricing() {
  return (
    <>
      <div >
        <div style={StySpecification.StylesContainer}>
          <div >
            <div >
              <h2 style={StySpecification.Title} className='header'>MS-SQL (Windows) 데이터베이스 요금안내</h2>

            </div>
          </div>
          <div style={StySpecification.TableScroll}>
            <div style={StySpecification.TableWrap}>
              <div style={StySpecification.ListProduct}>

                {Protitle({
                  classNameWrapper: StySpecification.InfPro,
                  classNameItem: StySpecification.ProductTitle,
                  PadProTable: StySpecification.PadProTable,
                  PadProtit: StySpecification.PadProtit,
                  ConTitle: StySpecification.ConTitle,
                  // Title: "hi",
                  Core: "상세정보",
                  G: "Core 수",
                  SD: "가격 (VAT별도/월)",
                  SG: "비고",

                })}

                {ProtitleNew({
                   classNameWrapper: StySpecification.InfProduct,
                   classNameItem: StySpecification.ProductTitle,
                   PadProTitle: StySpecification.PadProTitle,
                   Tableborder: StySpecification.Tableborder,
                   Tableborderlast: StySpecification.Tableborderlast,
                  Title: "SQL Server",
                  Core: "2012 ~2019 Standard",
                  G: "4",
                  SD: "320,000원",
                  SG: "4 Core 단위 1 Copy",

                })}

                {ProtitleNew({
                   classNameWrapper: StySpecification.InfProduct,
                   classNameItem: StySpecification.ProductTitle,
                   PadProTitle: StySpecification.PadProTitle,
                   Tableborder: StySpecification.Tableborder,
                   Tableborderlast: StySpecification.Tableborderlast,
                  Title: "SQL server 2019",
                  Core: "Express (제공예정)",
                  G: "4",
                  SD: "무료",
                  SG: "최대 4 Core",

                })}
                {ProtitleNew({
                   classNameWrapper: StySpecification.InfProduct,
                   classNameItem: StySpecification.ProductTitle,
                   PadProTitle: StySpecification.PadProTitle,
                   Tableborder: StySpecification.Tableborder,
                   Tableborderlast: StySpecification.Tableborderlast,
                  Title: "Windows Server",
                  Core: "2012 ~ 2019 server",
                  G: "-",
                  SD: "30,000원",
                  SG: "Windows Server 1대",

                })}
              </div>
            </div>
          </div>
          <TrafficFee/>
        </div>
      </div>
    </>

  );
}


const StySpecification = {
  StylesContainer: {
    boxShadow: "0 0.375rem 1.5rem 0 rgb(140 152 164 / 13%)",
    border: "1px solid #E7EAF3",
    borderRadius: "8px",
    padding: 20,
    marginTop: 30,
    marginBottom: 30,
  },
  StylesTitle: {
    textAlign: "center",
  },
  Title: {
    fontWeight: "bold",
    marginTop: "20px",
    marginBottom: "20px",
  },
  Text: {
    fontWeight: 600,
    marginBottom: "30px",
  },
  ColorText: {
    color: "white",
  },
  ProductTitle: {
    background: "#393939",
    fontWeight: "bold",
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    // paddingTop: 8,
    // paddingBottom: 8,

  },
  Tableborder: {
    borderLeft: "1px solid #D7E5ED",
    borderRight: "1px solid #D7E5ED",
  },
  Tableborderlast: {
    borderLeft: "1px solid #D7E5ED",
    borderRight: "1px solid #D7E5ED",
    borderBottom: "1px solid #D7E5ED",
  },
  ProTitleLeft: {
    fontWeight: 500,
    paddingTop: 8,
    paddingBottom: 8,
  },
  InfProduct: {
    borderRadius: "8px",
    width: "25%",
    marginLeft: 20,
    // border: "1px solid #D7E5ED",
    whiteSpace: "nowrap",
    minWidth: "170px",
  },
  InfPro: {
    borderRadius: "8px",
    width: "25%",
    textAlign: "right",
    fontWeight: 700,
    whiteSpace: "nowrap",
    minWidth: "130px",
  },

  ListProduct: {
    display: "flex",
   
  },
  ConTitle:{
    color:"black",
  },
  PadPro: {
    padding: "12px 0",
  },
  PadProtit: {
    padding: "6px 0",
  },
  PadProTable: {
    padding: "10px 0",
  },
  PadProTitle: {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
    background: "unset",
  },
  TableScroll:{
    position:"relative",
    width: "100%",
    margin:"auto",
    overflow:"hidden", 
    whiteSpace: "nowrap",
  },
  TableWrap:{
    width:"100%",
    overflow:"auto",
  }

}





export default ServerPricing;
